import { Link } from "@mui/material";
import { cssVar } from "../../theme/theme";

const LinkButton = ({
  text,
  onClick,
  color,
  style,
}: {
  text: string;
  onClick(): void;
  color?: string;
  style?: React.CSSProperties | undefined;
}) => {
  return (
    <Link
      onClick={onClick}
      style={style}
      sx={{
        cursor: "pointer",
        color: color ?? "var(--color-info-main)",
        textDecorationColor: color ?? "var(--color-info-main)",
        textDecoration: "none",
        "&:hover": {
          color: "var(--color-primary-main)",
        },
      }}
    >
      {text}
    </Link>
  );
};

export default LinkButton;
